export enum RecordingStatus {
	Completed = "COMPLETED",
	Processing = "PROCESSING",
	Ready = "READY",
	// LSP-19254: the delete gate in MediaLightBox depends on these three, which the DB enum
	// (contact-api src/types/RecordingStatus.ts) has always emitted but this one never declared.
	// Declared so an API-side rename becomes a type error rather than a silently-inverted gate on a
	// destructive control. Values are UPPERCASE because callers normalize the document's status before
	// comparing; the API spells them lowercase.
	Pending = "PENDING",
	InProgress = "INPROGRESS",
	Failed = "FAILED"
}
